<!-- 近期用水波动情况 -->
<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">近期用水波动情况</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div class="chart-details" @click="openModal">
          <img src="~@/assets/bigusers/largeScreen/details.png" title="更多" />
          <a-modal title="正反波动前100排名" :dialog-style="{ top: '100px' }" :width="600" v-model="detailsVisible"
            :footer="null" :mask="false" @cancel="closeModal">
            <template #closeIcon>
              <svg width="15" height="15" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
                style="color: #1055cf;">
                <path
                  d="M17.32,14.99L29.54,2.78c.62-.62,.62-1.63,0-2.25l-.07-.07c-.62-.62-1.63-.62-2.25,0L15.01,12.69,2.79,.46C2.17-.15,1.16-.15,.54,.46l-.07,.07C-.16,1.15-.16,2.16,.47,2.78L12.69,14.99,.47,27.21c-.62,.62-.62,1.63,0,2.25l.07,.07c.62,.62,1.63,.62,2.25,0l12.21-12.21,12.21,12.21c.62,.62,1.63,.62,2.25,0l.07-.07c.62-.62,.62-1.63,0-2.25l-12.21-12.21Z"
                  fill="currentColor" />
              </svg>
            </template>
            <div class="modal-content">
              <div class="div-button">
                <a-row :gutter="16">
                  <a-col :md="4" :sm="12" v-for="(item, index) in modalButtonType" :key="index">
                    <div class="modal-button disable-text-selection"
                      :class="{ 'active-button': selectedButton === index }" @click="getModalData(index)">
                      {{ item }}
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div class="div-table">
                <a-table :columns="columns" :data-source="dataSource" :row-key="(record, index) => index"
                  style="height: 431px;" :pagination="false" @change="handleTableChange" :key="tableKey">
                  <template slot="index" slot-scope="text, record, index">
                    <span>{{ current == 1 ? index + 1 : index + 1 + (current - 1) * 10 }}</span>
                  </template>

                </a-table>
                <div class="pagination-right">
                  <a-pagination :current="current" :page-size="pageSize" :total="total" :item-render="customItemRender"
                    @change="onPageChange" class="custom-pagination" :show-title="false" />
                </div>
              </div>
            </div>
          </a-modal>
        </div>
        <div style="height: 100%;">
          <div ref="volatilityChart" style="height: 300px; left: 10px;">

          </div>
        </div>
      </div>
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
  name: 'RightVolatility',
  data () {
    return {
      volatilityUrl: '/smart-water-major-users/major/users/user/user/count/consumption',
      volatilityTableUrl: '/smart-water-major-users/major/users/user/user/order/consumption/radio',
      columns: [
        {
          title: '排名',
          align: 'center', // 居中
          width: '50px',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
          width: '90px',
          ellipsis: true
        },
        {
          title: '用户编码',
          dataIndex: 'userCode',
          align: 'center'
        },
        {
          title: '当期用水量',
          dataIndex: 'waterConsumption',
          align: 'center'
        },
        {
          title: '上期用水量',
          dataIndex: 'waterLastTwoCount',
          align: 'center'
        },
        {
          title: '波动比例',
          dataIndex: 'fluctuationRatio',
          align: 'center',
          sorter: true,
        }
      ],
      detailsVisible: false,
      modalButtonType: ['居民用水', '非居民用水', '特种用水', '其他'],
      selectedButton: 0, // 默认选中第一个按钮
      current: 1,      // 当前页，必须是数字
      pageSize: 10,    // 每页条数，必须是数字
      total: 100,
      dataSource: [],
      // 排序参数
      sorter: {
        field: null,
        order: null
      },
      // 表格key，用于强制重新渲染
      tableKey: 0
    }
  },
  mounted () {
    this.initChart();
  },
  methods: {
    customItemRender (current, type, originalElement) {
      if (type === 'prev') {
        return <img src={require('@/assets/bigusers/largeScreen/left-arrow.png')} style="width:18px;height:18px;" />
      }
      if (type === 'next') {
        return <img src={require('@/assets/bigusers/largeScreen/right-arrow.png')} style="width:18px;height:18px;" />
      }
      return originalElement;
    },
    onPageChange (page) {
      this.current = page;
      // 分页时保持当前的排序状态
      this.getModalData(this.selectedButton);
    },
    initChart () {
      this.getVolatilityData();
      // createWaterMeterChart 现在在 getVolatilityData 中被调用
    },
    getCurrentMonth () {
      const currentDate = new Date();
      return currentDate.getMonth(); // getMonth() 返回 0-11，需要加1
    },
    getVolatilityData () {
      this.$http.get(this.volatilityUrl).then((res) => {
        // 动态获取所有日期键并排序
        const dateKeys = Object.keys(res.data).sort();

        // 如果数据少于2条，无法进行对比
        if (dateKeys.length < 2) {
          console.warn('数据不足，至少需要2个月的数据');
          return;
        }

        // 获取最后两个日期（最新的和上一个）
        const currentDateKey = dateKeys[dateKeys.length - 1]; // 最新日期 2025-08-28
        const lastDateKey = dateKeys[dateKeys.length - 2]; // 上一个日期 2025-07-28

        // 获取对应日期的数据
        const currentData = res.data[currentDateKey];
        const lastData = res.data[lastDateKey];

        // 从日期字符串中提取月份用于显示
        const currentMonth = new Date(currentDateKey).getMonth() + 1; // 获取月份 1-12
        const lastMonth = new Date(lastDateKey).getMonth() + 1;

        // 处理1-4的用水类型数据
        let yData1 = [];
        let yData2 = [];

        for (let i = 1; i <= 4; i++) {
          // 计算波动比例
          const currentValue = Number(currentData[i]) || 0;
          const lastValue = Number(lastData[i]) || 0;
          const volatility = lastValue > 0 ? ((currentValue - lastValue) / lastValue * 100).toFixed(1) : '0.0';

          yData1.push({
            value: currentValue,
            date: `${currentMonth}月份用水量`,
            volatility: volatility
          });

          yData2.push({
            value: lastValue,
            date: `${lastMonth}月份用水量`
          });
        }

        // 将数据传递给图表
        this.createWaterMeterChart(yData1, yData2);
      })
    },
    createWaterMeterChart (yData1 = [], yData2 = []) {
      const chartDom = this.$refs.volatilityChart;
      const myChart = echarts.init(chartDom);
      //创建Option对象
      let volatilityOption = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const firstParam = params[0];
            let result = `${firstParam.name}<br/>
                        ${params.map(item => `${item.data.date}：${item.value}m³`).join('<br/>')}
                        <br/>波动比例：${firstParam.data.volatility}%`;
            return result.replace(/\s+/g, ' ').trim();
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(42, 55, 226, 0.3)', // 浅蓝色半透明阴影
            }
          },
          textStyle: { // 悬浮框文字样式
            color: '#fff',
            fontSize: 12
          },
          backgroundColor: "rgba(42, 128, 226, 0.8)",
          borderWidth: 0
        },
        xAxis: {
          type: 'category',
          data: ['居民用水', '非居民用水', '特种用水', '其他'],
          axisLabel: {
            color: '#98BDFF' // 设置 y 轴文字颜色
          },
          axisLine: {
            lineStyle: {
              color: '#1519CA'  // 设置 y 轴线条颜色
            }
          },
        },
        yAxis: {
          // max: 12000,  // 最大值
          type: 'value',
          axisLabel: {
            color: '#98BDFF' // 设置 y 轴文字颜色
          },
          axisLine: {
            show: true, // 确保轴线是显示的
            lineStyle: {
              color: '#1519CA'  // 设置 y 轴线条颜色
            }
          },
          splitLine: { //网格线调整
            show: true, // 默认显示
            lineStyle: {
              color: 'rgba(152, 189, 255, 0.3)', // 自定义颜色（示例：半透明灰色）
            }
          }
        },
        grid: {
          top: 30,
          left: '55px',
        },
        graphic: {
          type: 'text',
          top: 5,          // 距离顶部10像素
          left: 50,        // 距离右侧20像素
          style: {
            text: 'm³',     // 单位文本
            fill: '#98BDFF',   // 文字颜色
            fontSize: 12,
          }
        },
        series: [
          {
            type: 'bar',
            data: yData1,
            barGap: 0,
            barWidth: 25, // 固定柱子宽度
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,    // 从左到右渐变
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [{
                  offset: 0, color: 'rgba(2, 22, 117, 0.5)' // 起始颜色（深蓝）
                }, {
                  offset: 1, color: '#284DF9' // 结束颜色（亮蓝）
                }]
              }
            }
          },
          {
            type: 'bar',
            data: yData2,
            barWidth: 25, // 固定柱子宽度
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,    // 从左到右渐变
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [{
                  offset: 0, color: 'rgba(149, 104, 8, 0.5)' // 起始颜色
                }, {
                  offset: 1, color: '#F9B728' // 结束颜色
                }]
              }
            }
          }
        ]
      };

      myChart.setOption(volatilityOption);
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    //打开
    openModal () {
      this.detailsVisible = true
      // 重置到初始状态
      this.resetModalState()
      // 延迟加载数据，确保表格完全重置后再加载
      this.$nextTick(() => {
        this.getModalData(0);
      })
    },

    // 重置弹窗状态
    resetModalState () {
      this.current = 1
      this.selectedButton = 0
      this.sorter = {
        field: null,
        order: null
      }
      // 强制重新渲染表格，清除排序状态
      this.tableKey += 1

      // 延迟清空数据，确保表格完全重置
      this.$nextTick(() => {
        this.dataSource = []
        this.total = 0
      })
    },

    // 关闭弹窗
    closeModal () {
      this.detailsVisible = false
      // 关闭时重置状态
      this.resetModalState()
    },
    getModalData (index, order = null) {
      this.dataSource = [];
      // 只有当 index 有值时才赋值
      if (index !== undefined) {
        this.selectedButton = index;
      }

      // 使用记住的排序参数，如果没有则使用传入的order参数
      const sortOrder = order || (this.sorter.order === 'ascend' ? 'asc' : 'desc');

      this.$http.get(this.volatilityTableUrl, {
        params: {
          page: this.current,
          limit: this.pageSize,
          waterType: this.selectedButton + 1,
          orderType: sortOrder
        }
      }).then((res) => {
        this.total = Number(res.data.total);
        this.dataSource = res.data.list;
      })
    },
    // 处理排序变化
    handleTableChange (pagination, filters, sorter) {
      // 记住排序值
      if (sorter && sorter.field) {
        this.sorter.field = sorter.field
        this.sorter.order = sorter.order
        const orders = sorter.order == 'ascend' ? 'asc' : 'desc';
        // 根据排序字段和顺序处理数据
        this.getModalData(this.selectedButton, orders);
      } else {
        // 如果没有排序，清空排序参数
        this.sorter.field = null
        this.sorter.order = null
        // 使用默认排序
        this.getModalData(this.selectedButton, 'desc');
      }
    },
  }
}

</script>


<style lang="less" scoped>
.disable-text-selection {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.mainWarp {
  height: 250px;
  width: 412px;
  position: relative;


  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .top {
    flex: 0 0 60px;
    /* 固定高度 14% */
    background: url(~@/assets/bigusers/largeScreen/topBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .middle {
    flex: 0 0 70%;
    /* 固定高度 60% */
    background: url(~@/assets/bigusers/largeScreen/middleBox.png) repeat;
    background-size: 100% auto;
    /* 水平拉伸，垂直平铺 */
  }

  .bottom {
    flex: 0 0 60px;
    /* 固定高度 20% */
    background: url(~@/assets/bigusers/largeScreen/bottomBox.png) no-repeat;
    background-size: 100% 100%;
    /* 完全填充 */
  }

  .img-title {
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;
    /* 确保标题在最上层 */

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}

.chart-container {
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  /* 确保在底层 */
}

.chart-details {
  position: absolute;
  top: -20px;
  right: 20px;
  width: 50px;
  height: 20px;
  cursor: pointer;
}

/deep/ .ant-modal-header {
  padding: 0;
  border: none
}

/deep/ .ant-modal-title {
  color: #0faae3;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

/deep/ .ant-modal-content {
  position: relative;
  background: transparent;
  padding-top: 30px;
  /* 顶部背景高度 */
  padding-bottom: 30px;
  /* 底部背景高度 */

  /* 顶部背景（伪元素） */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: url(~@/assets/bigusers/largeScreen/modalTop.png) no-repeat;
    background-size: 100% 100%;
  }

  /* 中部背景（实际内容区域） */
  &>div {
    background: url(~@/assets/bigusers/largeScreen/modalMiddle.png) repeat-y;
    background-size: 100% auto;
    height: 100%;
  }

  /* 底部背景（伪元素） */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: url(~@/assets/bigusers/largeScreen/modalBottom.png) no-repeat;
    background-size: 100% 100%;
  }
}

.modal-button {
  width: 92px;
  height: 32.5px;
  background: url(~@/assets/bigusers/largeScreen/modalButton.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 7px;
  font-weight: bold;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

.modal-button:hover,
.modal-button.active-button {
  background: url(~@/assets/bigusers/largeScreen/modalButtonHighlight.png) no-repeat;
  background-size: 100% 100%;
}

.div-table {
  margin-top: 10px;
}

::v-deep .ant-modal-body {
  padding-bottom: 0;
}

/* 表头样式 */
::v-deep .ant-table-thead>tr>th {
  background: rgba(32, 94, 250, 0.5) !important;
  /* 深蓝色背景 */
  color: #fff !important;
  /* 白色字体 */
  font-weight: bold;
  border: none;
  padding: 10px;
}

/* 表格内容样式 */
::v-deep .ant-table-tbody>tr>td {
  background: rgba(22, 51, 102, 0.1) !important;
  /* 内容区深蓝色 */
  color: #fff !important;
  /* 白色字体 */
  border: none;
}

/* 去除表格边框 */
::v-deep .ant-table {
  background: transparent !important;
}

::v-deep .ant-table-tbody>tr>td {
  border-top: 6px solid rgba(16, 30, 58, 0.7) !important;
  /* 间隔色，和背景色接近即可 */
  background: rgba(157, 184, 252, 0.1) !important;
  color: #fff !important;
  padding: 6px 10px;
}

/* 去掉最后一行的分隔线 */
::v-deep .ant-table-tbody>tr:last-child>td {
  border-bottom: none !important;
}

.pagination-right {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  /* 距离表格底部的间距，可调整 */
}

::v-deep .custom-pagination .ant-pagination-item {
  background: transparent !important;
  border: none !important;
  color: #2b7cff !important;
  /* 普通数字蓝色 */
  font-size: 12px;
  box-shadow: none !important;
  transition: color 0.2s;
  font-family: 'DIN Alternate', 'Microsoft YaHei', Arial, sans-serif;
}

::v-deep .custom-pagination .ant-pagination-item-active {
  color: #6ffcff !important;
  /* 当前页高亮蓝色 */
  font-weight: bold;
  background: none !important;
  border: none !important;
  text-shadow: 0 0 8px #3cf6ff, 0 0 2px #3cf6ff;
  min-width: 16px;
}

::v-deep .custom-pagination .ant-pagination-item a {
  color: inherit !important;
  background: none !important;
}

::v-deep .custom-pagination .ant-pagination-item-ellipsis {
  color: #2b7cff !important;
  font-size: 18px;
}

::v-deep .custom-pagination .ant-pagination-prev .ant-pagination-item-link,
::v-deep .custom-pagination .ant-pagination-next .ant-pagination-item-link {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ant-table-placeholder {
  display: none !important;
}
</style>
